import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export default function PolicyGatePage() {
  const { user, updateUser, logout } = useAuth();
  const [policy, setPolicy] = useState(null);
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/policy").then((r) => setPolicy(r.data)).catch((e) => setError(formatApiError(e)));
  }, []);

  async function accept() {
    setBusy(true);
    setError("");
    try {
      const response = await api.post("/auth/acknowledge", { text_hash: policy.text_hash, accepted: true });
      updateUser(response.data.user);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="policy-gate" data-testid="policy-gate">
      <section className="policy-card">
        <header>
          <ShieldCheck size={22} />
          <div>
            <h1>Confidentiality and acceptable use</h1>
            <p>Before you continue, {user?.first_name}, please read and accept this statement. It is recorded once per version{policy ? ` (${policy.version})` : ""}.</p>
          </div>
        </header>
        {policy ? <blockquote data-testid="policy-text">{policy.text}</blockquote> : <p className="pairing-meta">Loading the statement…</p>}
        {error && <p className="form-message error-message" data-testid="policy-error">{error}</p>}
        <label className="policy-check">
          <input data-testid="policy-accept-checkbox" type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>I have read and accept this statement.</span>
        </label>
        <div className="policy-actions">
          <button className="button button-secondary" data-testid="policy-sign-out" type="button" onClick={logout}>Sign out</button>
          <button className="button button-primary" data-testid="policy-accept-button" disabled={!checked || !policy || busy} type="button" onClick={accept}>I accept</button>
        </div>
      </section>
    </div>
  );
}
